import { createAction, props } from '@ngrx/store';

export const SetTitle = createAction('[Meta] Set meta title', props<{ title: string }>());
export const SetTags = createAction('[Meta] Set meta tags', props<{ properties: { [property: string]: string } }>());

export const SetCanonical = createAction('[Meta] Set canonical url', props<{ url: string }>());
